import { GameSessionResult } from '../../../assets/enums/game-session.enum.ts';
import { type PerformanceMlAgreement } from '../performance-api.ts';
import { toPercent } from './money.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';

const countWhere = (
  sessions: SessionsServiceSession[],
  mlResult: GameSessionResult,
  result: GameSessionResult
) =>
  sessions.filter((session) => session.ml_result === mlResult && session.result === result).length;

export const buildMlAgreement = (completed: SessionsServiceSession[]): PerformanceMlAgreement => {
  const decided = completed.filter((session) => session.ml_result !== null);
  const matched = decided.filter((session) => session.ml_result === session.result).length;
  const { Won, Lost } = GameSessionResult;

  return {
    decided: decided.length,
    matched,
    match_rate: toPercent(matched, decided.length),
    won_won: countWhere(decided, Won, Won),
    lost_lost: countWhere(decided, Lost, Lost),
    won_lost: countWhere(decided, Won, Lost),
    lost_won: countWhere(decided, Lost, Won),
    no_decision: completed.length - decided.length,
  };
};
